// eslint-disable-next-line no-unused-vars
export default theme => ({
  dialog: {},
  dangerColor: {
    color: theme.palette.danger.main,
    verticalAlign: 'middle'
  },
});
